window.buttonFileUpload = function(input, loadArgs) {
  const wrapper = input.closest('.btn-upload-input');
  if (!wrapper) return;

  const content = wrapper.querySelector('.btn__content');
  const hiddenInput = wrapper.querySelector('input[type="hidden"]');

  if (!input.files.length) return;

  const file = input.files[0];
  const maxSize = 2 * 1024 * 1024; // 2MB
  const allowedExtensions = ['pdf', 'doc', 'docx'];

  if (file.size > maxSize) {
    noticeError('File is too large. Maximum size is 2MB.');
    input.value = '';
    return;
  }

  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();

  if (!allowedExtensions.includes(fileExtension)) {
    noticeError('Invalid file format. Allowed formats are: PDF, DOC, DOCX');
    input.value = '';
    return;
  }

  if (content) {
    content.textContent = fileName;
  }

  initFile(input);

  if (loadArgs && typeof load === 'function') {
    load(...loadArgs);
  }
};